<form [formGroup]="formGroup">
  <div formArrayName="experiences">
    <div
      class="card-data"
      *ngFor="let experience of experiences.controls; let i = index"
      [formGroupName]="i"
    >
      <div class="d-flex">
        <h4>
          {{ "Work Experience" | translate }}
        </h4>
        <i
          *ngIf="this.experiences.length > 1"
          (click)="removeExperience(i)"
          class="col-auto bi bi-trash3 delete-icon"
        ></i>
      </div>

      <label>{{ "Job title" | translate }}</label>
      <input
        type="text"
        formControlName="title"
        placeholder="{{ 'Enter your Job title' | translate }}"
      />

      <label>{{ "Company Name" | translate }}</label>

      <input
        type="text"
        formControlName="company"
        placeholder="{{ 'Enter Your Company Name' | translate }}"
      />

      <div class="d-flex justify-content-between">
        <div class="date">
          <label>{{ "Start Date" | translate }}</label>

          <input
            type="date"
            formControlName="startDate"
            placeholder="{{ 'Select date' | translate }}"
          />
        </div>
        <div class="date">
          <label>{{ "End Date" | translate }}</label>

          <input
            type="date"
            formControlName="endDate"
            placeholder="{{ 'Select date' | translate }}"
          />
        </div>
      </div>
      <div class="d-flex mt-3 align-items-center">
        <p-inputSwitch />
        <label class="m-0 mx-2">{{ "Current Position" | translate }}</label>
      </div>
      <label>{{
        "Add numeric Achievements & Duties as possible" | translate
      }}</label>

      <textarea
        type="text"
        formControlName="objective"
        placeholder="{{ 'Achievements & Duties' | translate }}"
      ></textarea>
    </div>

    <div class="card-data add-new" (click)="addExperience()">
      <h6>{{ "Add New Work experience" | translate }}</h6>
      <i class="bi bi-plus-circle"></i>
    </div>

    <div class="next-container px-4">
      <button class="border-button m-3" (click)="onPrevious()">
        {{ "Back" | translate }}
      </button>
      <button class="gradient-button m-3" (click)="onNext()">
        {{ "Next" | translate }}
      </button>
    </div>
  </div>
</form>
